module.exports = "/images/sv.svg";